import { useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import FormControl from "../../components/common/FormControl";
import Layout from "../../components/global/layout"
import { RxEnvelopeClosed } from "react-icons/rx";
import methodModel from "../../methods/methods";

const ContactUs = () => {
  const [form, setForm] = useState({
    fullName: '',
    email: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const inValidEmail = methodModel.emailvalidation(form?.email);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true)
    if (!inValidEmail) return;
    ApiClient.post("contactUs/add", form).then((response) => {
      if (response && response.success) {
        setSuccessMessage("Your message has been sent successfully.");
        setTimeout(() => {
          setSuccessMessage("");
        }, 4000);
        setForm({ fullName: '', email: '', message: '', });
      } else {
        setSuccessMessage("");
        alert("Something went wrong. Please try again.");
      }
      setIsSubmitting(false)
    })
  };

  return (
    <Layout>
      <div className="bg-white px-4 py-10 lg:py-20">
        <div className="mt-6 max-w-6xl max-lg:max-w-3xl contact-us-section mx-auto bg-[#000] rounded-xl abdbgimages">
          <div className="grid lg:grid-cols-2 items-center gap-14 sm:p-8 p-4 font-[sans-serif]">
            <div>
              <h1 className="text-4xl font-bold text-white">Get in Touch</h1>
              <p className="text-sm text-gray-300 mt-4 leading-relaxed">Need help or have a testimony? We'd love to hear from you.</p>
              <ul className="mt-6 space-y-8">
                <li className="flex items-center">
                  <RxEnvelopeClosed className="text-primary text-xl" />
                  <p className="text-white text-sm ml-4">
                    frumme2ucard@gmail.com
                  </p>
                </li>
              </ul>
              <ul className="flex mt-6 space-x-4">
                <li onClick={e => { window.open("https://www.youtube.com/@Frumme2ucard", "_blank") }} className="bg-gray-200 hover:bg-gray-300 hover:shadow-lg p-3 cursor-pointer rounded-full flex items-center justify-center shrink-0">
                  <img src="./assets/img/youtube.svg" alt="facebook_icon" className="w-[20px]" />
                </li>
                <li onClick={e => { window.open("https://www.instagram.com/frum_me2u/?hl=en", "_blank") }} className="bg-gray-200 hover:bg-gray-300 hover:shadow-lg p-3 cursor-pointer rounded-full flex items-center justify-center shrink-0">
                  <img src="./assets/img/instagram.svg" alt="facebook_icon" className="w-[20px]" />
                </li>
                <li onClick={e => { window.open("https://www.facebook.com/profile.php?id=61579483935100", "_blank") }} className="bg-gray-200 hover:bg-gray-300 hover:shadow-lg p-3 cursor-pointer rounded-full flex items-center justify-center shrink-0">
                  <img src="./assets/img/Facebook.svg" alt="facebook_icon" className="w-[20px]" />
                </li>
              </ul>
            </div>
            <div className="bg-gray-100 p-6 rounded-lg">
              {successMessage && <p className="text-center text-green-600 mb-4">{successMessage}</p>}
              <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  <div>
                    <FormControl
                      type="text"
                      name="fullname"
                      label="Full Name"
                      placeholder="Your Name"
                      value={form.fullName}
                      onChange={(e) => setForm((prev) => ({ ...prev, fullName: e }))}
                      required
                    />
                  </div>
                  <div>
                    <FormControl
                      type="email"
                      name="email"
                      label="Email"
                      placeholder="Your Email"
                      value={form.email}
                      onChange={(e) => setForm((prev) => ({ ...prev, email: e }))}
                      required
                    />
                    {form?.email && !inValidEmail && isSubmitting && (
                      <div className="text-red-600">
                        Please enter valid email
                      </div>
                    )}
                  </div>
                  <div className="col-span-1 lg:col-span-2">
                    <div className="mb-4">
                      <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                        Message <span className="text-red-600">*</span>
                      </label>
                      <textarea
                        id="message"
                        name="message"
                        value={form?.message}
                        onChange={(e) => setForm(prev => ({ ...prev, message: e.target.value }))}
                        className="mt-1 p-2 w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        rows="5"
                        placeholder="Your Message"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-span-1 lg:col-span-2 text-center">
                    <button
                      type="submit"
                      className="w-full sm:w-auto bg-indigo-600 text-white font-semibold py-2 px-4 rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:bg-gray-400"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ContactUs;